//Expresión regular para email.
export const REG_EXP_EMAIL = /^([a-z0-9_.-]+)@([\da-z.-]+)\.([a-z]{2,3})$/;

//Expresiones regulares para validación de campos

export const ALPHANUM_SPACE_HT = /^[0-9a-zA-Z,.,# \sñÑáéíóúÁÉÍÓÚ]$/;
export const ALPHANUM_SPACE = /^[0-9a-zA-Z,. \sñÑáéíóúÁÉÍÓÚ]$/;
export const REG_EXP_TEL_NUMBERS = /^[0-9]{8,45}$/;

//Formato de fecha
export const DATE_FORMAT = "dd/mm/yyyy";
export const DATE_FORMAT_CALENDAR = "dd/mm/yy";
export const MONTH_YEAR_FORMAT_CALENDAR = "MM/yy";

//Constante para cambiar a español el componente Calendar
let actualYear = new Date().getFullYear();
export const CALENDAR_ES = {
    firstDayOfWeek: 1,
    dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
    dayNamesMin: ["D", "L", "M", "Mi", "J", "V", "S"],
    monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    today: 'Hoy',
    clear: 'Limpiar',
    dateFormat: 'dd/mm/yy',
    weekHeader: 'Sm',
    yearRange: "1970:" + actualYear.toString(),
    yearRangeFuture: "1970:" + (actualYear + 10).toString(),
};


//Constantes de roles
export const INTERNO = 0;
export const EXTERNO = 1;
export const PTT_ROL = 1;
export const PTM_ROL = 2;
export const INTERNO_STR = "Interno";

//Constantes para la disponibilidad de las emisoras
export const HIGH_AVAILABILITY = 1;
export const MEDIUM_AVAILABILITY = 2;
export const LOW_AVAILABILITY = 3;

//Constantes de dirección por institución
export const ADDRESS_BY_INSTITUTION = 1;
export const ADDRESS_BY_ACCOUNT = 2;

//Constante de línea de crédito máxima
export const MAX_CREDIT_AMOUNT = 99999999999.99;

//Constantes de Garantias
export const GUARANTEE_MARGIN = 3;
export const GUARANTEE_EXCESS = 2;

//Constantes de numero de flujos
export const NOT_IN_FLOW = 0;

//Constantes de estatus
export const INCUMPLIMIENTO = 'I';
export const MARGIN_CALL = 'LL';

//Constantes para los nombres de pantalla
export const MAINTENANCE_INSTRUMENT = 'maintenanceInstrument';

/////////////////////////////////////////Fideicomiso////////////////////////////////////////////////////////
//Constantes para status de garantías
export const INSTRUCCION_RECIBIDA_FIDUCIARIO = "RECIBIDA EN FIDUCIARIO-SERVICE";
export const INSTRUCCION_ENVIADA = "ENVIADA";
export const INSTRUCCION_AUTORIZADA = "AUTORIZADA";
export const INSTRUCCION_RECHAZADA = "RECHAZADA";
export const INSTRUCCION_CANCELADA = "CANCELADA";
export const INSTRUCCION_LIQUIDADA = "LIQUIDADA";
export const INSTRUCCION_CREADA = "CREADA";
export const INSTRUCCION_LIQUIDADA_LABEL = "Liquidada"
export const INSTRUCCION_NO_LIQUIDADA_LABEL = "Creada"
export const INSTRUCCION_CANCELADA_LABEL = "Cancelada"
export const INSTRUCCION_MANUAL_LABEL = "Manual"

//Constantes para status de titulos
export const INSTRUCCION_PENDIENTE_LABEL = "Pendiente"

//Constantes para tipo de instrucción
export const INSTRUCTION_TYPE_RECEIVE_ID = "instruction.receive";
export const INSTRUCTION_TYPE_SEND_ID = "instruction.send";
export const INSTRUCTION_TYPE_RECEIVE_LABEL = "Entrada";
export const INSTRUCTION_TYPE_SEND_LABEL = "Salida";
/////////////////////////////////////////Fideicomiso////////////////////////////////////////////////////////

/////////////////////////////////////////Custodia////////////////////////////////////////////////////////
export const CUSTODY_TYPE_RECEIVE_ID = "Entrada";
export const CUSTODY_TYPE_SEND_ID = "Salida";
export const CUSTODY_TYPE_RECEIVE_LABEL = "Entrada";
export const CUSTODY_TYPE_SEND_LABEL = "Salida";
/////////////////////////////////////////Custodia////////////////////////////////////////////////////////

///////////////////////////////////////// Bilaterales ////////////////////////////////////////////////////////
export const LENDER = "LENDER";
export const BORROWER = "BORROWER";
